import { motion } from 'framer-motion';
import { fadeUp, staggerContainer, staggerItem, viewportOnce } from '../../utils/animations';
import {
    Crosshair, BookOpen, UserCheck, Clock, CalendarCheck, RefreshCcw,
} from 'lucide-react';

const includedCards = [
    { icon: Crosshair, title: 'Precision Hiring System', body: "Role design, skills testing, behavioral screening, structured interviews, and offer guidance. You're installing a repeatable hiring framework, not gambling on resumes." },
    { icon: BookOpen, title: 'Structured Onboarding Roadmap', body: "Every hire gets a clear path from day one. We don't drop someone in and hope for the best. The roadmap shortens ramp time and sets expectations from the start." },
    { icon: UserCheck, title: 'Dedicated Customer Success Rep', body: 'One person who knows your business. Reach them via Slack, phone, or text. No support tickets. No black hole.' },
    { icon: Clock, title: 'Monthly Timeclock Audit', body: "Every month we review your VA's logs for drift, inefficiency, and accountability issues. Proactive oversight, not reactive damage control." },
    { icon: CalendarCheck, title: 'Annual Business Review', body: 'Once a year we review VA performance, systems maturity, documentation progress, and your future hiring roadmap.' },
    { icon: RefreshCcw, title: 'Free Replacement Guarantee', body: "If a hire doesn't work out, we replace them. No restart fee. No additional recruiting charge. That's the standard." },
];

export function WhatsIncluded() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="whats-included">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 mb-4 tracking-tight">
                        Everything You Need. Nothing You Don't.
                    </h2>
                </motion.div>

                <motion.div
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                >
                    {includedCards.map((card) => (
                        <motion.div
                            key={card.title}
                            variants={staggerItem}
                            className="bg-white border border-gray-100 rounded-sm p-8 shadow-sm hover:shadow-md hover:border-gold-200 transition-all duration-300 group"
                        >
                            <div className="w-10 h-10 rounded-sm bg-navy-900 flex items-center justify-center mb-5 group-hover:bg-gold-400 transition-colors duration-300">
                                <card.icon size={18} className="text-white" strokeWidth={1.5} />
                            </div>
                            <h3 className="font-montserrat font-bold text-base text-navy-900 mb-3">{card.title}</h3>
                            <p className="text-[#6B7280] text-sm leading-relaxed">{card.body}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
